import { useMemo, type ReactNode } from 'react';
import { MOCK_JWT_TOKEN } from '../api/client';
import { AuthContext, type AuthState } from './AuthContext';

export function MockAuthProvider({ children }: { children: ReactNode }) {
  const value = useMemo<AuthState>(
    () => ({
      isLoaded: true,
      isSignedIn: true,
      userId: 'user_local_dev',
      email: 'dev@immersive.local',
      getToken: async () => MOCK_JWT_TOKEN,
      signOut: async () => {
        console.warn('Sign-out is not available in mock auth mode');
      },
    }),
    [],
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
